/**
 * Profile settings (TMMAPP-0012) — `PATCH /v1/me` with generated `SettingsPatchRequest`. The body
 * carries only the keys the person changed; every key is optional ("omit to leave unchanged").
 */
import type { MeResponse, SettingsPatchRequest } from './generated';
import { request } from './client';
import { normalizeMe, type Me, type PayeeNamingMode } from './me';

export type { SettingsPatchRequest };

export async function patchMe(body: SettingsPatchRequest): Promise<Me> {
  return normalizeMe(await request<MeResponse>('PATCH', '/v1/me', { json: body }));
}

/**
 * Sets the payee naming mode (TMMAPI-0193 U3). Switching renames nothing: a switch to `AI_ALL`
 * answers `runSuggested`, and the person starts a run themselves (never this call).
 */
export async function patchPayeeNamingMode(
  mode: PayeeNamingMode,
): Promise<{ me: Me; runSuggested: boolean }> {
  const body: SettingsPatchRequest = { payeeNamingMode: mode };
  const wire = await request<MeResponse>('PATCH', '/v1/me', { json: body });
  return { me: normalizeMe(wire), runSuggested: wire.runSuggested === true };
}
